import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-workbook-publish-success-modal-with-preview', {
    textAlign: 'left',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-link-datasource, .tb-workbook-publish-success-modal-with-preview .tb-link-workbook', {
    height: '18px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-datasources .tb-datasources-title', {
    fontSize: '14px',
    fontWeight: 'normal',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-connections-section', {
    padding: 0,
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items', {
    padding: '0 18px 0 0',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body', {
    marginTop: '12px',
    marginBottom: '12px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-workbook-wrapper, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-workbook-wrapper, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-datasource-wrapper, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-datasource-wrapper', {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-workbook-wrapper .tb-published-icon, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-workbook-wrapper .tb-published-icon, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-datasource-wrapper .tb-published-icon, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-datasource-wrapper .tb-published-icon', {
    flex: '0 0 auto',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-workbook-wrapper .tb-published-name, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-workbook-wrapper .tb-published-name, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-workbook-body .tb-published-item .tb-datasource-wrapper .tb-published-name, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources-body .tb-published-item .tb-datasource-wrapper .tb-published-name', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    fontWeight: 'bold',
    paddingLeft: '2px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-datasources', {
    marginTop: '18px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-device-preview, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-data-refresh', {
    paddingLeft: '22px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-device-preview .tb-device-preview-text, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-data-refresh .tb-device-preview-text, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-device-preview .tb-data-refresh-text, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-data-refresh .tb-data-refresh-text, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-device-preview .tb-data-refresh-link, .tb-workbook-publish-success-modal-with-preview .tb-published-items .tb-data-refresh .tb-data-refresh-link', {
    lineHeight: '16px',
    fontWeight: 'normal',
    fontSize: '12px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-publish-details', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
    marginTop: '18px',
    padding: '12px',
});

cssRule('.tb-workbook-publish-success-modal-with-preview .tb-datasource-publish-details-popover-trigger', {
    textDecoration: 'underline',
});

cssRule('.publish-complete-dialog-footer', {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    '-webkit-justify-content': 'space-between',
    alignItems: 'center',
    margin: '12px 0',
});

cssRule('.publish-complete-an-ext-section', {
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    borderTop: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    paddingBottom: '15px',
    paddingTop: '15px',
});

cssRule('.publish-complete-an-ext-no-connection-selected', {
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'row',
});

cssRule('.publish-complete-an-ext-no-connection-selected-text', {
    fontWeight: 'bold',
});

cssRule('.publish-complete-an-ext-no-connection-warning', {
    marginBottom: '15px',
});

cssRule('.publish-complete-an-ext-row', {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '-webkit-justify-content': 'space-between',
});

cssRule('.publish-complete-an-ext-dropdown', {
    width: '350px',
});

cssRule('.publish-complete-an-ext-dropdown-item', {
    display: 'flex',
    flexDirection: 'row',
    width: '290px',
});

cssRule('.publish-complete-an-ext-apply-button', {
    alignSelf: 'flex-end',
});

